<template>
    <page title="resetPasswordTitle">
        <template #pageContainer>
            <form v-if="!isPasswordReseted">
				<v-row><v-col>
                <v-text-field outlined dense
					hide-details="auto"
                    v-model="password"
                    type="password"
                    :label="$t('text.password')"
                    :error-messages="passwordErrors"
                    required
                    @input="$v.password.$touch()"
                    @blur="$v.password.$touch()">
                </v-text-field>
				</v-col></v-row>
				<v-row><v-col>

                <v-text-field outlined dense
					hide-details="auto"
                    v-model="confirmPassword"
                    type="password"
                    :label="$t('text.confirmPassword')"
                    :error-messages="confirmPasswordErrors"
                    required
                    @input="$v.confirmPassword.$touch()"
                    @blur="$v.confirmPassword.$touch()">
                </v-text-field>
				</v-col></v-row>

                <v-btn
                    class="mr-4"
                    :disabled="$v.$invalid"
                    @click="resetPassword">
                    {{ $t(`text.resetPasswordButton`) }}
                </v-btn>
            </form>

            <v-alert v-else type="success">
                {{ $t(`text.resetPasswordSuccess`) }}
                <nav-item :to="{name: 'login'}" title="login"></nav-item>
            </v-alert>
            <spinner :loading="loading"></spinner>
        </template>
    </page>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';

import authActions from '../store/actions/auth';
import namespace from '../store/namespace';

import Page from '../general/Page.vue';
import NavItem from '../navigation/Item.vue';
import Spinner from '../general/Spinner.vue';

import modelState from '../mixins/modelState';

export default {
	name: 'ResetPassword',
	mixins: [modelState],
	components: {
		Page,
		NavItem,
		Spinner,
	},
	validations: {
		password: {
			required,
		},
		confirmPassword: {
			required,
		},
	},
	data() {
		return {
			userId: this.$route.query.userId,
			code: this.$route.query.code,
			password: '',
			confirmPassword: '',
			confirmed: false,
			loading: false,
		};
	},
	computed: {
		isPasswordReseted() {
			return this.confirmed;
		},
		passwordErrors() {
			const errors = [];

			if (!this.$v.password.$dirty) return errors;

			const apiErrors = this.validateProperty('Password');

			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			!this.$v.password.required && errors.push(this.$i18n.t('text.errorPasswordRequired'));

			return errors;
		},
		confirmPasswordErrors() {
			const errors = [];

			if (!this.$v.confirmPassword.$dirty) return errors;

			const apiErrors = this.validateProperty('ConfirmPassword');

			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			!this.$v.confirmPassword.required && errors.push(this.$i18n.t('text.errorConfirmPasswordRequired'));

			return errors;
		},
	},
	methods: {
		...mapActions(namespace.AUTH, [authActions.RESET_PASSWORD]),
		async resetPassword() {
			this.loading = true;
			this.$v.$touch();

			if (!this.$v.$invalid) {
				const resetPassword = {
					password: this.password,
					confirmPassword: this.confirmPassword,
					code: this.code,
					userId: this.userId,
				};

				try {
					this.modelState = {};
					await this.RESET_PASSWORD(resetPassword);

					this.confirmed = true;
				} catch (e) {
					if (e.response.status === 422) {
						this.modelState = e.response.data;
						if (this.modelError()) {
							throw new Error(this.modelError());
						}
					}

					throw e;
				} finally {
					this.loading = false;
				}
			}
			this.loading = false;
		},
	},
};
</script>
